if (typeof boostPFSThemeConfig !== "undefined") {
  // Override Settings
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSConfig.custom.products_per_page,
      loadProductFirst: true,
      numberFilterTree: 2,
      //showLimitList: '24,36,48'
    },
  };
}

var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
var boostPFSFinished = false;

(function () {
  // Add this
  BoostPFS.inject(this); // Add this

  /**************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM ****************/
  function prepareShopifyData(data) {

    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    if (data.variants && data.variants.length > 0) {
      firstVariant = data.variants[0];
      if (
        Utils.getParam("variant") !== null &&
        Utils.getParam("variant") != ""
      ) {
        var paramVariant = data.variants.filter(function (e) {
          return e.id == Utils.getParam("variant");
        });
        if (typeof paramVariant[0] !== "undefined")
          firstVariant = paramVariant[0];
      } else {
        for (var i = 0; i < data.variants.length; i++) {
          if (data.variants[i].available) {
            firstVariant = data.variants[i];
            break;
          }
        }
      }
    }
    return data;
  }

  /***************************** BUILD PRODUCT LIST ****************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data, index) {
    if (!data) data = this.data;
    if (!index) index = this.index;

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;

    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);

    // Grid Template
    // Add Grid Width class
    itemHtml = itemHtml.replace(
      /{{gridWidthClass}}/g,
      buildGridWidthClass(data)
    );

    // Add Label
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));

    // Add Image Properties
    var imageWrapperClass =
      boostPFSConfig.custom.show_secondary_image && images.length > 1
        ? "product-item__image-wrapper--with-secondary"
        : "";
    itemHtml = itemHtml.replace(/{{imageWrapperClass}}/g, imageWrapperClass);

    var imageAspectRatioClass =
      "aspect-ratio--" + boostPFSConfig.custom.product_image_size;
    itemHtml = itemHtml.replace(
      /{{imageAspectRatioClass}}/g,
      imageAspectRatioClass
    );

    var imagePadding = 100;
    if (images && images.length > 0 && images[0].width && images[0].height) {
      imagePadding = 100 / (images[0].width / images[0].height);
    }
    itemHtml = itemHtml.replace(/{{imagePadding}}/g, imagePadding);

    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

    // Add Info
    var itemInfoHtml =
      boostPFSConfig.custom.product_price_position == "after_title"
        ? "{{itemVendor}}{{itemTitleWrapper}}{{itemRating}}{{metaFields}}{{itemSwatch}}{{itemPrice}}"
        : "{{itemPrice}}{{itemTitleWrapper}}{{itemVendor}}{{itemRating}}{{itemSwatch}}";

    itemHtml = itemHtml.replace(/{{itemInfo}}/g, itemInfoHtml);

    // Add Vendor
    var itemVendorHtml = boostPFSConfig.custom.show_vendor
      ? '<a class="product-item__vendor link">' + data.vendor + "</a>"
      : "";
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Title
    var itemTitleWrapperHtml =
      '<a href="{{itemUrl}}" class="product-item__title text--strong link" data-product-id="{{itemId}}" data-product-title="{{itemTitle}}">{{itemTitle}}</a>';
    itemHtml = itemHtml.replace(/{{itemTitleWrapper}}/g, itemTitleWrapperHtml);

    // Add meta data
    itemHtml = itemHtml.replace(/{{metaFields}}/g, buildMetafieldsGIM(data));

    // Add price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPriceJAO(data));

    // Add Swatch
    var itemSwatchHtml = boostPFSConfig.custom.show_color_swatch
      ? buildSwatch(data)
      : "";
    itemHtml = itemHtml.replace(/{{itemSwatch}}/g, itemSwatchHtml);

    // Add Reviews
    if (
      typeof Integration === "undefined" ||
      !Integration.hascompileTemplate("reviews")
    ) {
      var itemReviewHtml = boostPFSConfig.custom.show_reviews_badge
        ? boostPFSTemplate.reviewHtml
        : "";
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewHtml);
    }

    // show product rating
    itemHtml = itemHtml.replace(/{{itemRating}}/g, buildRating(data));

    // Add Inventory
    itemHtml = itemHtml.replace(/{{itemInventory}}/g, buildInventoryJAO(data));

    // Add Quickview
    itemHtml = itemHtml.replace(/{{itemQuickView}}/g, buildQuickView(data));

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(
      /{{itemUrl}}/g,
      buildCustomUrlWithVariant(data)
    );
    return itemHtml;
  };

  // Custom url function
  function buildCustomUrlWithVariant(data) {
    var urlHtml = Utils.buildProductItemUrl(data);

    if (data.variant_id !== undefined) {
      urlHtml += "?variant=" + data.variant_id;
    }
    return urlHtml;
  }
  /************************ BUILD PRODUCT ITEM ELEMENTS ***********************/
  function buildGridWidthClass() {
    var gridWidthClass = "";
    switch (boostPFSConfig.custom.products_per_row) {
      case 3:
        gridWidthClass = "1/3--desk";
        break;
      case 4:
        gridWidthClass = "1/4--desk";
        break;
      default:
        gridWidthClass = "1/3--desk";
        break;
    }
    return gridWidthClass;
  }

  function buildLabels(data) {
    // Build Sale label
    var saleLabelHtml = "";
    if (boostPFSConfig.custom.show_discount && onSale) {
      var saveAmount = "";
      if (boostPFSConfig.custom.discount_mode === "saving") {
        saveAmount = Utils.formatMoney(
          data.compare_at_price_min - data.price_min
        );
      } else {
        saveAmount =
          Math.round(
            ((data.compare_at_price_min - data.price_min) * 100) /
              data.compare_at_price_min
          ) + "%";
      }
      saleLabelHtml = boostPFSTemplate.saleLabelHtml.replace(
        /{{savings}}/g,
        saveAmount
      );
    }

    //Build tag labels
    var tagLabelHtmls = "";
    if (data.tags && data.tags.length > 0) {
      var tagLabelHtml1 = "";
      var tagLabelHtml2 = "";
      for (var i = 0; i < data.tags.length; i++) {
        var tag = data.tags[i];
        if (tag.indexOf("__label:") !== -1) {
          tagLabelHtml1 += boostPFSTemplate.tagLabelHtml.replace(
            /{{tagLabelClass}}/g,
            "product-label--custom1"
          );
          tagLabelHtml1 = tagLabelHtml1.replace(
            /{{tagLabel}}/g,
            tag.split("__label:")[1]
          );
        }

        if (tag.indexOf("__label1:") !== -1) {
          tagLabelHtml1 += boostPFSTemplate.tagLabelHtml.replace(
            /{{tagLabelClass}}/g,
            "product-label--custom1"
          );
          tagLabelHtml1 = tagLabelHtml1.replace(
            /{{tagLabel}}/g,
            tag.split("__label1:")[1]
          );
        }

        if (tag.indexOf("__label2:") !== -1) {
          tagLabelHtml2 += boostPFSTemplate.tagLabelHtml.replace(
            /{{tagLabelClass}}/g,
            "product-label--custom2"
          );
          tagLabelHtml2 = tagLabelHtml2.replace(
            /{{tagLabel}}/g,
            tag.split("__label2:")[1]
          );
        }
      }
      tagLabelHtmls = tagLabelHtml1 + tagLabelHtml2;
    }

    // Build Labels
    return tagLabelHtmls + saleLabelHtml;
  }

  function buildImages(data) {
    // Build Main Image
    var firstImageHtml = boostPFSTemplate.imageHtml;
    if (images.length > 0) {
      var thumbUrl = Utils.optimizeImage(images[0].src, "60x");
      firstImageHtml = firstImageHtml.replace(/{{imageUrl}}/g, thumbUrl);
      firstImageHtml = firstImageHtml.replace(/{{imageId}}/g, images[0].id);
      firstImageHtml = firstImageHtml.replace(
        /{{image_url}}/g,
        Utils.optimizeImage(images[0].src, "{width}x")
      );
    } else {
      firstImageHtml = firstImageHtml.replace(
        /{{imageUrl}}/g,
        boostPFSConfig.general.no_image_url
      );
      firstImageHtml = firstImageHtml.replace(/{{imageId}}/g, "");
      firstImageHtml = firstImageHtml.replace(
        /{{image_url}}/g,
        Utils.optimizeImage(boostPFSConfig.general.no_image_url, "{width}x")
      );
    }

    // Build Image Swap
    var secondImageHtml = "";
    if (boostPFSConfig.custom.show_secondary_image && images.length > 1) {
      var flipImageUrl = Utils.optimizeImage(images[1].src, "60x");
      secondImageHtml = boostPFSTemplate.imageHtml;
      secondImageHtml = secondImageHtml.replace(/{{imageUrl}}/g, flipImageUrl);
      secondImageHtml = secondImageHtml.replace(/{{imageId}}/g, images[1].id);
      secondImageHtml = secondImageHtml.replace(
        /{{image_url}}/g,
        Utils.optimizeImage(images[1].src, "{width}x")
      );
      secondImageHtml = secondImageHtml.replace(
        /{{imageClass}}/g,
        "product-item__secondary-image"
      );
      firstImageHtml = firstImageHtml.replace(
        /{{imageClass}}/g,
        "product-item__primary-image"
      );
    } else {
      firstImageHtml = firstImageHtml.replace(
        /{{imageClass}}/g,
        "product-item__primary-image"
      );
    }

    // JAO - Add data attributes for image overlays
    var selectedVariantId = "";
    if (data.variants.length > 1) {
      selectedVariantId = data.variant_id;
    } else {
    }

    var thicknessOverlayHtml = "";
    data.metafields.find((metafield) => {
      if (
        metafield.id &&
        metafield.id == data.variant_id &&
        metafield.key == "dikte"
      ) {
        thicknessOverlayHtml =
          '<div class="size-overlay"><span>' + metafield.value + " mm</span></div>";
      } else if (metafield.key == "dikte" && thicknessOverlayHtml == "") {
        thicknessOverlayHtml =
          '<div class="size-overlay"><span>' + metafield.value + " mm</span></div>";
      }
    });

    // ISDE overlay
    var isdeOverlayHtml = "";
    data.metafields.find((metafield) => {
      if (metafield.key.indexOf("meldcode") > -1) {
        isdeOverlayHtml =
          `<div class="isde-overlay old-style"> <svg
            width="50"
            height="59"
            viewBox="0 0 50 59"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            title="Dit product komt in aanmerking voor de Investeringssubsidie Duurzame Energie en Energiebesparing (ISDE)">
            <path d="M50 43.5906L50 0L2.80461e-05 -4.37114e-06L1.27912e-05 43.5906L24.992 59L50 43.5906Z" fill="#FBC94D"/>
            <path d="M10.4448 16.592V25.808C10.4448 25.904 10.3488 26 10.2528 26H8.46081C8.36481 26 8.26881 25.904 8.26881 25.808V16.592C8.26881 16.496 8.36481 16.4 8.46081 16.4H10.2528C10.3488 16.4 10.4448 16.496 10.4448 16.592ZM12.5299 22.768H14.0819C14.2739 22.768 14.3699 22.848 14.4019 23.008C14.5619 23.824 15.2499 24.336 16.7699 24.336C18.3059 24.336 18.9939 23.76 18.9939 23.072C18.9939 22.624 18.6739 22.224 17.7139 22.144L15.2179 21.936C13.2659 21.776 12.2259 20.88 12.2259 19.44C12.2259 17.776 13.6819 16.24 16.5139 16.24C19.4419 16.24 20.7219 17.6 20.7219 19.136C20.7219 19.28 20.6099 19.408 20.4179 19.408H18.8339C18.6739 19.408 18.5779 19.36 18.5459 19.168C18.4499 18.608 17.9059 18.064 16.4979 18.064C15.1539 18.064 14.4019 18.608 14.4019 19.312C14.4019 19.744 14.6899 20.064 15.5699 20.128L18.0499 20.336C20.2899 20.528 21.1699 21.648 21.1699 22.976C21.1699 24.48 19.8739 26.16 16.7699 26.16C13.8419 26.16 12.2259 24.768 12.2259 23.184V23.056C12.2259 22.896 12.3539 22.768 12.5299 22.768ZM27.2127 26H23.1327C23.0367 26 22.9407 25.904 22.9407 25.808V16.592C22.9407 16.496 23.0367 16.4 23.1327 16.4H27.1807C30.2207 16.4 32.4927 18.272 32.4927 21.2C32.4927 24.096 30.5727 26 27.2127 26ZM27.1807 18.224H25.1167V24.176H27.2127C29.2447 24.176 30.3167 23.024 30.3167 21.2C30.3167 19.376 29.0047 18.224 27.1807 18.224ZM41.5008 22H36.4448V24.176H42.0768C42.1728 24.176 42.3008 24.304 42.3008 24.4V25.776C42.3008 25.872 42.1728 26 42.0768 26H34.4608C34.3648 26 34.2688 25.904 34.2688 25.808V16.592C34.2688 16.496 34.3648 16.4 34.4608 16.4H41.9808C42.0768 16.4 42.2048 16.528 42.2048 16.624V18C42.2048 18.096 42.0768 18.224 41.9808 18.224H36.4448V20.176H41.5008C41.5968 20.176 41.7248 20.304 41.7248 20.4V21.776C41.7248 21.872 41.5968 22 41.5008 22Z" fill="black"/>
            <path d="M10.8101 36.0791C10.5698 36.0791 10.3413 36.0527 10.1245 36C9.91064 35.9473 9.72168 35.8638 9.55762 35.7495C9.39355 35.6353 9.26465 35.4858 9.1709 35.3013C9.08008 35.1138 9.03467 34.8882 9.03467 34.6245H9.74219C9.74219 34.9585 9.84473 35.1943 10.0498 35.332C10.2578 35.4668 10.5171 35.5342 10.8276 35.5342C11.106 35.5342 11.3345 35.4814 11.5132 35.376C11.6948 35.2676 11.7856 35.0903 11.7856 34.8442C11.7856 34.6333 11.7036 34.4766 11.5396 34.374C11.3784 34.2715 11.0928 34.1719 10.6826 34.0752C10.3486 33.9961 10.0674 33.9053 9.83887 33.8027C9.61035 33.6973 9.43896 33.5654 9.32471 33.4072C9.21045 33.2461 9.15332 33.0439 9.15332 32.8008C9.15332 32.6104 9.19287 32.4434 9.27197 32.2998C9.354 32.1533 9.4668 32.0317 9.61035 31.9351C9.75684 31.8384 9.92822 31.7666 10.1245 31.7197C10.3208 31.6699 10.5332 31.645 10.7617 31.645C10.9873 31.645 11.1982 31.6714 11.3945 31.7241C11.5938 31.7769 11.7681 31.8589 11.9175 31.9702C12.0698 32.0815 12.1899 32.2251 12.2778 32.4009C12.3657 32.5767 12.4097 32.7876 12.4097 33.0337H11.6978C11.6978 32.729 11.6069 32.5137 11.4253 32.3877C11.2437 32.2617 11.0225 32.1987 10.7617 32.1987C10.498 32.1987 10.2842 32.2456 10.1201 32.3394C9.95605 32.4331 9.87402 32.5796 9.87402 32.7788C9.87402 32.8931 9.91064 32.9897 9.98389 33.0688C10.0571 33.1479 10.1802 33.2197 10.353 33.2842C10.5259 33.3457 10.7588 33.4116 11.0518 33.4819C11.3711 33.5581 11.6392 33.6489 11.856 33.7544C12.0728 33.8599 12.2354 33.9961 12.3438 34.1631C12.4551 34.3271 12.5107 34.5381 12.5107 34.7959C12.5107 35.0186 12.4668 35.2119 12.3789 35.376C12.2939 35.5371 12.1738 35.6704 12.0186 35.7759C11.8662 35.8784 11.686 35.9546 11.478 36.0044C11.2729 36.0542 11.0503 36.0791 10.8101 36.0791ZM14.9761 36.0659C14.481 36.0659 14.1235 35.9282 13.9038 35.6528C13.6841 35.3774 13.5742 34.998 13.5742 34.5146V31.7197H14.3125V34.4136C14.3125 34.6069 14.3345 34.7798 14.3784 34.9321C14.4224 35.0845 14.5059 35.2031 14.6289 35.2881C14.752 35.373 14.9292 35.4155 15.1606 35.4155C15.4829 35.4155 15.7524 35.3496 15.9692 35.2178C16.186 35.083 16.3604 34.9277 16.4922 34.752V31.7197H17.2305V36H16.5229L16.501 35.3408C16.3633 35.5107 16.1685 35.6748 15.9165 35.833C15.6675 35.9883 15.354 36.0659 14.9761 36.0659ZM20.7241 36.0791C20.4077 36.0791 20.1382 36.019 19.9155 35.8989C19.6929 35.7759 19.5112 35.6074 19.3706 35.3936L19.3311 36H18.6455V30.085H19.3794V32.4053C19.5288 32.1797 19.7236 31.9966 19.9639 31.856C20.207 31.7153 20.4912 31.645 20.8164 31.645C21.165 31.645 21.4668 31.7285 21.7217 31.8955C21.9766 32.0596 22.1729 32.3057 22.3105 32.6338C22.4512 32.9619 22.5215 33.3706 22.5215 33.8599C22.5215 34.3462 22.4468 34.7549 22.2974 35.0859C22.1509 35.4141 21.9429 35.6616 21.6733 35.8286C21.4038 35.9956 21.0874 36.0791 20.7241 36.0791ZM20.5879 35.4771C20.9746 35.4771 21.2676 35.3379 21.4668 35.0596C21.666 34.7783 21.7656 34.3813 21.7656 33.8687C21.7656 33.3413 21.6719 32.937 21.4844 32.6558C21.2998 32.3745 21.0259 32.2339 20.6626 32.2339C20.355 32.2339 20.0942 32.3159 19.8804 32.48C19.6694 32.644 19.5024 32.8433 19.3794 33.0776V34.7256C19.4937 34.9424 19.6504 35.1226 19.8496 35.2661C20.0488 35.4067 20.2949 35.4771 20.5879 35.4771ZM25.1626 36.0791C24.9224 36.0791 24.6938 36.0527 24.4771 36C24.2632 35.9473 24.0742 35.8638 23.9102 35.7495C23.7461 35.6353 23.6172 35.4858 23.5234 35.3013C23.4326 35.1138 23.3872 34.8882 23.3872 34.6245H24.0947C24.0947 34.9585 24.1973 35.1943 24.4023 35.332C24.6104 35.4668 24.8696 35.5342 25.1802 35.5342C25.4585 35.5342 25.687 35.4814 25.8657 35.376C26.0474 35.2676 26.1382 35.0903 26.1382 34.8442C26.1382 34.6333 26.0562 34.4766 25.8921 34.374C25.731 34.2715 25.4453 34.1719 25.0352 34.0752C24.7012 33.9961 24.4199 33.9053 24.1914 33.8027C23.9629 33.6973 23.7915 33.5654 23.6772 33.4072C23.563 33.2461 23.5059 33.0439 23.5059 32.8008C23.5059 32.6104 23.5454 32.4434 23.6245 32.2998C23.7065 32.1533 23.8193 32.0317 23.9629 31.9351C24.1094 31.8384 24.2808 31.7666 24.4771 31.7197C24.6733 31.6699 24.8857 31.645 25.1143 31.645C25.3398 31.645 25.5508 31.6714 25.7471 31.7241C25.9463 31.7769 26.1206 31.8589 26.27 31.9702C26.4224 32.0815 26.5425 32.2251 26.6304 32.4009C26.7183 32.5767 26.7622 32.7876 26.7622 33.0337H26.0503C26.0503 32.729 25.9595 32.5137 25.7778 32.3877C25.5962 32.2617 25.375 32.1987 25.1143 32.1987C24.8506 32.1987 24.6367 32.2456 24.4727 32.3394C24.3086 32.4331 24.2266 32.5796 24.2266 32.7788C24.2266 32.8931 24.2632 32.9897 24.3364 33.0688C24.4097 33.1479 24.5327 33.2197 24.7056 33.2842C24.8784 33.3457 25.1113 33.4116 25.4043 33.4819C25.7236 33.5581 25.9917 33.6489 26.2085 33.7544C26.4253 33.8599 26.5879 33.9961 26.6963 34.1631C26.8076 34.3271 26.8633 34.5381 26.8633 34.7959C26.8633 35.0186 26.8193 35.2119 26.7314 35.376C26.6465 35.5371 26.5264 35.6704 26.3711 35.7759C26.2188 35.8784 26.0386 35.9546 25.8306 36.0044C25.6255 36.0542 25.4028 36.0791 25.1626 36.0791ZM28.0234 36V31.7197H28.7573V36H28.0234ZM28.3882 30.9155C28.2505 30.9155 28.1392 30.876 28.0542 30.7969C27.9722 30.7148 27.9312 30.6123 27.9312 30.4893C27.9312 30.3662 27.9722 30.2651 28.0542 30.186C28.1392 30.104 28.2505 30.063 28.3882 30.063C28.5259 30.063 28.6372 30.104 28.7222 30.186C28.8071 30.2651 28.8496 30.3662 28.8496 30.4893C28.8496 30.6123 28.8071 30.7148 28.7222 30.7969C28.6372 30.876 28.5259 30.9155 28.3882 30.9155ZM31.6401 36.0791C31.2915 36.0791 30.9897 35.9956 30.7349 35.8286C30.48 35.6616 30.2822 35.4126 30.1416 35.0815C30.0039 34.7476 29.9351 34.3359 29.9351 33.8467C29.9351 33.3604 30.0083 32.9546 30.1548 32.6294C30.3042 32.3042 30.5137 32.0596 30.7832 31.8955C31.0527 31.7285 31.3706 31.645 31.7368 31.645C32.0415 31.645 32.3066 31.7124 32.5322 31.8472C32.7578 31.979 32.9395 32.1592 33.0771 32.3877V30.085H33.811V36H33.1167L33.0771 35.376C32.9248 35.584 32.7285 35.7539 32.4883 35.8857C32.248 36.0146 31.9653 36.0791 31.6401 36.0791ZM31.7896 35.4771C32.103 35.4771 32.3638 35.4038 32.5718 35.2573C32.7798 35.1079 32.9482 34.9292 33.0771 34.7212V33.0732C32.957 32.833 32.7988 32.6353 32.6025 32.48C32.4092 32.3218 32.1646 32.2427 31.8687 32.2427C31.479 32.2427 31.1846 32.3818 30.9854 32.6602C30.7891 32.9385 30.6909 33.334 30.6909 33.8467C30.6909 34.377 30.7832 34.7812 30.9678 35.0596C31.1553 35.3379 31.4292 35.4771 31.7896 35.4771ZM35.2217 36V31.7197H35.9556V36H35.2217ZM35.5864 30.9155C35.4487 30.9155 35.3374 30.876 35.2524 30.7969C35.1704 30.7148 35.1294 30.6123 35.1294 30.4893C35.1294 30.3662 35.1704 30.2651 35.2524 30.186C35.3374 30.104 35.4487 30.063 35.5864 30.063C35.7241 30.063 35.8354 30.104 35.9204 30.186C36.0054 30.2651 36.0479 30.3662 36.0479 30.4893C36.0479 30.6123 36.0054 30.7148 35.9204 30.7969C35.8354 30.876 35.7241 30.9155 35.5864 30.9155ZM39.1548 36.0791C38.689 36.0791 38.3066 35.9824 38.0078 35.7891C37.7119 35.5928 37.4922 35.3276 37.3486 34.9937C37.2051 34.6567 37.1333 34.2788 37.1333 33.8599C37.1333 33.4233 37.2021 33.0396 37.3398 32.7085C37.4805 32.3745 37.6929 32.1138 37.9771 31.9263C38.2642 31.7388 38.6274 31.645 39.0669 31.645C39.6499 31.645 40.1069 31.8208 40.438 32.1724C40.769 32.5239 40.9346 33.0293 40.9346 33.6885C40.9346 33.7324 40.9331 33.7852 40.9302 33.8467C40.9272 33.9053 40.9229 33.9478 40.917 33.9741H37.8672C37.8701 34.2524 37.9141 34.5088 37.999 34.7432C38.0869 34.9746 38.2246 35.1606 38.4121 35.3013C38.5996 35.4419 38.8472 35.5122 39.1548 35.5122C39.4829 35.5122 39.7393 35.436 39.9238 35.2837C40.1084 35.1284 40.2051 34.9058 40.2139 34.6157H40.939C40.9302 34.9175 40.8525 35.1782 40.7061 35.3979C40.5596 35.6147 40.3545 35.7832 40.0908 35.9033C39.8271 36.0205 39.5151 36.0791 39.1548 36.0791ZM37.8716 33.438H40.2095C40.2007 33.0396 40.0967 32.7349 39.8975 32.5239C39.6982 32.313 39.4214 32.2075 39.0669 32.2075C38.7095 32.2075 38.4282 32.313 38.2231 32.5239C38.021 32.7319 37.9038 33.0366 37.8716 33.438Z" fill="black"/>
          </svg></div>`;
      }
    });

    var html = firstImageHtml + secondImageHtml + thicknessOverlayHtml + isdeOverlayHtml;
    return html;
  }

  function buildPrice(data) {
    var priceHtml = '<div class="product-item__price-list price-list">';
    if (data.price_min) {
      priceHtml +=
        '<span class="price {{priceClass}}" data-money-convertible="">{{amount}}</span>';

      var priceAmount = (priceAmount = Utils.formatMoney(data.price_min));
      if (priceVaries) {
        priceAmount = boostPFSConfig.label.from.replace(
          /{{price_min}}/g,
          Utils.formatMoney(data.price_min)
        );
      }
      priceHtml = priceHtml.replace(/{{amount}}/g, priceAmount);
      priceHtml = priceHtml.replace(
        /{{priceClass}}/g,
        onSale ? "price--highlight" : ""
      );

      if (onSale) {
        priceHtml +=
          '<span class="price price--compare" data-money-convertible="">' +
          Utils.formatMoney(data.compare_at_price_min) +
          "</span>";
      }
    }
    priceHtml += "</div>";
    return priceHtml;
  }

  function translatePackaging(packaging_meta) {
    if(!packaging_meta) {
      return boostPFSConfig.label.packaging;
    }
    switch(packaging_meta.value.toLowerCase()) {
      case 'rol':
      case 'rolle':
      case 'roll':
        return boostPFSConfig.label.roll;
      case 'pallet':
      case 'palette':
        return boostPFSConfig.label.pallet;
      case 'plaat':
      case 'platte':
      case 'platten':
        return boostPFSConfig.label.plate;
      default:
        return boostPFSConfig.label.packaging;
    }
  }

  // m2 prijs tonen
  function buildPriceJAO(data) {
    var variantId = data.variant_id;
    var isVariant = data.variant_id !== undefined;

    var selected_variant = firstVariant;

    var packaging_type = data.metafields.find(function (metafield) {
      if (metafield.key == "type_verpakking") {
        return metafield.value.toLowerCase();
      }
    });

    // bereken de prijzen. 
    // eerst kijken naar de normale prijzen met evt normale kortingen (dus geen volumekorting)
    var discount_percentage = 0;
    var reduction_factor = 1;
    var product_price = selected_variant.price;
    var product_price_max = selected_variant.compare_at_price;

    if (product_price_max != null && product_price_max > product_price) {
      discount_percentage = Math.round(((product_price_max - product_price) * 100) / product_price_max);
      var reduction_factor = (100 - discount_percentage) / 100.0;
    } else {
      product_price_max = selected_variant.price      
    }

    // kijken of dit product een unit prijs heeft vanuit shopify zelf
    var unit = null;
    var unit_price_max = null;
    var unit_price_min = null;
    var unit_qty = null;
    var boostProducts = collProducts || []

    // boostProducts komt vanuit de collection page omdat we vanuit boost niet alle benodigde data krijgen
    if (boostProducts !== undefined) {
      boostProducts.find(function (prod) {        
        if (prod.id == data.id) {
          // pak de eerste variant (voor nu)
          var unit_price_measurement = prod.variants[0].unit_price_measurement;
          if(unit_price_measurement != null) {
            unit = unit_price_measurement.quantity_unit;
            if (unit == "mm") {
              unit_qty = unit_qty / 1000;
              unit = "m1";
            } else {
              unit_qty = unit_price_measurement.quantity_value;
            }
            
            unit_price_max = prod.variants[0].unit_price / 100;
            unit_price_min = unit_price_max;

            if(discount_percentage > 0) {
              // de unit prijs is incl korting, maar we willen de prijs excl korting ook weten (ivm van/voor)
              unit_price_max = +(product_price_max / unit_qty).toFixed(2) 
            }            
          }        
          return;
        }
      });
    }
    if(unit == null) {
      // geen units vanuit shopify. Misschien vanuit metafield (oude methode)?  
      var unit_qty = data.metafields.find(function (metafield) {
        if (metafield.key == "m2-per-pak") {
          if ((isVariant && variantId == metafield.id) || !isVariant) {
            return metafield.value;
          }
        }
      })

      if(unit_qty != null) {
        unit_qty = unit_qty.value;
        unit = "m2";
        unit_price_max = product_price_max / unit_qty;
        unit_price_min = unit_price_max;
      }
    }

    if(discount_percentage > 0) {
      unit_price_min = +(unit_price_max * reduction_factor).toFixed(2);
    }

    var unit_html = "";
    if(unit == "m1" || unit == "m") {
        unit_html = "p/m<sup>1</sup>";
    } else if (unit == "m2") {        
      unit_html = "p/m<sup>2</sup>";
    }

    var volume_discount = data.metafields.find(function (metafield) {
      if (metafield.key == "offer") {
        return metafield.value;
      }
    });

    var volume_discount_percentage = 0;
    if (typeof volume_discount !== "undefined") {
      var volumeDiscountObj = JSON.parse(volume_discount.value);
      if (volumeDiscountObj[0].status == true) {
        volumeDiscountObj["0"].price_level.forEach(
          (priceLevel) => (volume_discount_percentage = priceLevel.discount)
        );
      }
    }

    if (volume_discount_percentage > 0) {
      // dit zijn vanaf prijzen
      reduction_factor = (100 - volume_discount_percentage) / 100;
      unit_price_min = +(unit_price_max * reduction_factor).toFixed(2)
      product_price = +(product_price_max * reduction_factor).toFixed(2);
    } 

    if (unit == null) {
      var priceHtml = '<div class="product-item__price-list price-list">';
        priceHtml += '  <div class="price">';
        priceHtml += '    <div class="part-price">';
        priceHtml += '      {{from}}';
        priceHtml += '      <span class="part-price-amount">{{product_price}}</span>'
        priceHtml += '      {{per}} {{packaging_type}}'
        priceHtml += '    </div>';
        priceHtml += '  </div>';
    } else {
      var priceHtml = '<div class="product-item__price-list price-list">';
        priceHtml += '  <div class="price">';
        priceHtml += '    <div class="part-price">';
        priceHtml += '      {{from}}';
        priceHtml += '      <span class="part-price-amount">{{unit_price_min}}</span>'
        priceHtml += '      {{unit_html}}'
        priceHtml += '    </div>';
        priceHtml += '    <div class="unit-price">';
        priceHtml += '      {{from}}';
        priceHtml += '      <span class="part-price-amount">{{product_price}}</span>'
        priceHtml += '      {{per}} {{packaging_type}}';
        priceHtml += '    </div>';
        priceHtml += '  </div>';
    }

    if(volume_discount_percentage > 0) {
      priceHtml = priceHtml.replace(/{{from}}/g, boostPFSConfig.label.from + ' ');
    } else {
      priceHtml = priceHtml.replace(/{{from}}/g, '');
    }

    priceHtml = priceHtml.replace(/{{per}}/g, boostPFSConfig.label.per);

    priceHtml = priceHtml.replace(/{{unit_price_min}}/g, Utils.formatMoney(+unit_price_min));
    priceHtml = priceHtml.replace(/{{unit_html}}/g, unit_html);

    priceHtml = priceHtml.replace(/{{product_price}}/g, Utils.formatMoney(+product_price));
    priceHtml = priceHtml.replace(
              /{{packaging_type}}/g, translatePackaging(packaging_type)
            );
    priceHtml = priceHtml.replace(/€/g, '');
    
    return priceHtml;
  }

  // toon normale prijs
  function GIMBasicPriceLabel(priceHtml, data) {
    priceHtml +=
      '<span class="price {{priceClass}}" data-money-convertible="">{{vanaf}}{{amount}}</span>';

    var priceAmount = Utils.formatMoney(data.price_min);
    if (priceVaries) {
      priceAmount = boostPFSConfig.label.from.replace(
        /{{price_min}}/g,
        Utils.formatMoney(data.price_min)
      );
    }
    priceHtml = priceHtml.replace(/{{amount}}/g, priceAmount);
    priceHtml = priceHtml.replace(/{{priceClass}}/g, onSale ? "price--highlight" : "");

    if (onSale) {
      priceHtml +=
        '<span class="price price--compare" data-money-convertible="">' +
        Utils.formatMoney(data.compare_at_price_min) +
        "</span>";
    }

    return priceHtml;
  }

  function buildMetafieldsGIM(data) {
    var metafieldsHtml = '<ul class="product-item__metafields">';

    var isVariant = data.variant_id !== undefined;

    var thicknessValue = "";
    var rdValue = "";
    var extraLabel = "";
    var extraValue = "";

    var lambdaValue = "";
    var lengthValue = "";

    if (isVariant) {
      for (var i = 0; i < data.metafields.length; i++) {
        if (
          data.metafields[i].id == data.variant_id &&
          data.metafields[i].key == "dikte"
        ) {
          thicknessValue = data.metafields[i].value;
        }

        if (
          data.metafields[i].id == data.variant_id &&
          data.metafields[i].key == "rd-waarde"
        ) {
          rdValue = data.metafields[i].value;
        }

        if (
          data.metafields[i].id == data.variant_id &&
          data.metafields[i].key == "lambda"
        ) {
          lambdaValue = data.metafields[i].value;
        }

        if (
          data.metafields[i].id == data.variant_id &&
          data.metafields[i].key == "lengte"
        ) {
          lengthValue = data.metafields[i].value;
        }
      }
    } else {
      data.metafields.find(function (metafield) {
        if (metafield.key == "dikte") {
          thicknessValue = metafield.value;
          return;
        }
      });

      data.metafields.find(function (metafield) {
        if (metafield.key == "rd-waarde") {
          rdValue = metafield.value;
          return;
        }
      });

      data.metafields.find(function (metafield) {
        if (metafield.key == "lambda") {
          lambdaValue = metafield.value;
          return;
        }
      });

      data.metafields.find(function (metafield) {
        if (metafield.key == "lengte") {
          lengthValue = metafield.value;
          return;
        }
      });
    }

    var col_i = 0;
    while (col_i < data.collections.length) {
      var col = data.collections[col_i];

      if (col.handle.indexOf("rol") > -1) {
        extraLabel = boostPFSConfig.label.length;
        extraValue = lengthValue;
        break;
      }
      if (
        col.handle == "pir-2-zijdig-aluminium" ||
        col.handle == "pir-spouwmuur" ||
        col.handle == "pir-afschot-isolatie"
      ) {
        extraLabel = boostPFSConfig.label.caching;
        extraValue = "2-zijdig aluminium";
        break;
      }
      if (col.handle.indexOf("platen") > -1) {
        extraLabel = boostPFSConfig.label.lambda;
        extraValue = lambdaValue;
        break;
      }

      col_i++;
    }

    if (thicknessValue != "") {
      metafieldsHtml += "<li>";
      metafieldsHtml += boostPFSConfig.label.thickness + thicknessValue;
      metafieldsHtml += "</li>";
    }

    if (rdValue != "") {
      metafieldsHtml += "<li>";
      metafieldsHtml += boostPFSConfig.label.rd + rdValue;
      metafieldsHtml += "</li>";
    }

    if (extraLabel != "" && extraValue != "") {
      metafieldsHtml += "<li>";
      metafieldsHtml += extraLabel + extraValue;
      metafieldsHtml += "</li>";
    }

    metafieldsHtml += "</ul>";

    return metafieldsHtml;
  }

  function buildRating(data) {
    var ratingBadgeHtml = data.metafields.find(function (metafield) {
      if (metafield.key == "badge") {
        return metafield.value;
      }
    });

    if (typeof ratingBadgeHtml !== "undefined") {
      return (
        `<div class="product-item-rating">${ratingBadgeHtml.value}</div>`
      );
    } else {
      return `<div class="product-item-rating"></div>`;
    }
  }

  function buildSwatch(data) {
    var swatchHtml = "";
    if (boostPFSConfig.custom.show_filter_color_swatch) {
      var color_labels =
        "color,colour,couleur,colore,farbe,색,色,カラー,färg,farve".split(",");
      var foundColorOption = false;
      var swatchItems = [];
      // Color Swatch
      data.options_with_values.forEach(function (option, optionIndex) {
        if (foundColorOption) return;

        if (color_labels.indexOf(option.name.toLowerCase()) !== -1) {
          foundColorOption = true;
          option.values.forEach(function (colorValue, colorIndex) {
            var colorName = colorValue.title;
            var variantId = "";

            // Get variant with the color
            var variant = null;
            data.variants.forEach(function (dataVariant) {
              var variantColorName =
                dataVariant.merged_options[optionIndex].split(":")[1];
              if (variantColorName == colorName) {
                if (!variant) {
                  variant = dataVariant;
                } else if (!variant.image && dataVariant.image) {
                  variant = dataVariant;
                }
                variantId = dataVariant.id;
              }
            });

            // Get variant image info
            var variantImageInfo = {
              src: boostPFSConfig.general.no_image_url,
              id: 0,
              width: 480,
              height: 480,
            };
            if (variant) {
              if (data.images_info.length > 0)
                variantImageInfo = data.images_info[0];
              data.images_info.forEach(function (image_info) {
                if (image_info.src == variant.image) {
                  variantImageInfo = image_info;
                }
              });
            }

            // Build swatch item
            if (variant) {
              var fileUrl =
                boostPFSConfig.general.file_url.split(/\/(?=[^\/]+$)/);
              var imageSwatchUrl =
                fileUrl[0] +
                "/" +
                Utils.slugify(colorName) +
                "_64x64.png" +
                fileUrl[1];
              var swatchItemHtml =
                '<div class="color-swatch {{whiteColorClass}}">' +
                '<input class="color-swatch__radio" type="radio" {{checked}} aria-hidden="true" ' +
                'name="collection-template-{{itemId}}" ' +
                'id="collection-template-{{itemId}}-{{colorIndex}}" ' +
                'value="{{colorName}}" ' +
                'data-variant-url="{{variantUrl}}" ' +
                'data-image-id="{{variantImageId}}" ' +
                'data-image-url="{{variantImageUrl}}" ' +
                'data-image-widths="[200,300,400,500,600,700]" ' +
                'data-image-aspect-ratio="{{aspectRatio}}">' +
                '<label class="color-swatch__item" ' +
                'for="collection-template-{{itemId}}-{{colorIndex}}" ' +
                'style="background-image: url({{imageBackground}}); background-color: {{colorBackground}}" ' +
                'title="{{colorName}}">' +
                "</label>" +
                '<a href="{{itemUrl}}" class="color-swatch__item-link">+{{colorIndexBackwards}}</a>' +
                "</div>";

              swatchItemHtml = swatchItemHtml.replace(
                /{{whiteColorClass}}/g,
                colorName.toLowerCase() == "white" ? "color-swatch--white" : ""
              );
              swatchItemHtml = swatchItemHtml.replace(
                /{{checked}}/g,
                colorIndex == 0 ? 'checked="checked"' : ""
              );
              swatchItemHtml = swatchItemHtml.replace(
                /{{colorIndex}}/g,
                colorIndex
              );
              swatchItemHtml = swatchItemHtml.replace(
                /{{colorIndexBackwards}}/g,
                option.values.length - colorIndex
              );
              swatchItemHtml = swatchItemHtml.replace(
                /{{colorName}}/g,
                colorName
              );
              swatchItemHtml = swatchItemHtml.replace(
                /{{colorBackground}}/g,
                Utils.slugify(colorName).split("-").pop()
              );
              swatchItemHtml = swatchItemHtml.replace(
                /{{imageBackground}}/g,
                imageSwatchUrl
              );
              swatchItemHtml = swatchItemHtml.replace(
                /{{variantUrl}}/g,
                Utils.buildProductItemUrl(data) + "?variant=" + variant.id
              );
              swatchItemHtml = swatchItemHtml.replace(
                /{{variantImageId}}/g,
                variantId
              );
              swatchItemHtml = swatchItemHtml.replace(
                /{{variantImageUrl}}/g,
                variantImageInfo ? variantImageInfo.src : ""
              );
              swatchItemHtml = swatchItemHtml.replace(
                /{{aspectRatio}}/g,
                variantImageInfo
                  ? variantImageInfo.width / variantImageInfo.height
                  : ""
              );
              swatchItems.push(swatchItemHtml);
            }
          });
        }
      });
      if (swatchItems.length > 0) {
        swatchHtml =
          '<div class="product-item__swatch-list">' +
          '<div class="color-swatch-list">' +
          swatchItems.join(" ") +
          "</div>" +
          "</div>";
      }
    }
    return swatchHtml;
  }

  function buildInventory(data) {
    // wordt niet gebruikt.
    var inventoryHtml = "";
    if (
      boostPFSConfig.custom.show_inventory_quantity &&
      data.template_suffix != "pre-order"
    ) {
      inventoryHtml =
        '<span class="product-item__inventory inventory {{inventoryClass}}">{{inventoryText}}</span>';
      if (data.available) {
        var should_calculate_inventory = true;
        for (var i = 0; i < data.variants.length; i++) {
          var varianti = data.variants[i];

          if (
            varianti.inventory_policy == "continue" ||
            varianti.inventory_management == null
          ) {
            should_calculate_inventory = false;
            break;
          }
        }
        if (
          should_calculate_inventory &&
          boostPFSConfig.custom.low_inventory_threshold > 0
        ) {
          var numberInStock = 0;
          for (var j = 0; j < data.variants.length; j++) {
            var variantj = data.variants[j];
            if (variantj.inventory_management) {
              numberInStock += variantj.inventory_quantity;
            }
          }
          if (numberInStock <= boostPFSConfig.custom.low_inventory_threshold) {
            var inventoryText =
              numberInStock == 1
                ? boostPFSConfig.label.low_stock_with_quantity_count.one
                : boostPFSConfig.label.low_stock_with_quantity_count.other;
            inventoryText = inventoryText.replace(/{{count}}/g, numberInStock);
            inventoryHtml = inventoryHtml.replace(
              /{{inventoryClass}}/g,
              " inventory--low"
            );
            inventoryHtml = inventoryHtml.replace(
              /{{inventoryText}}/g,
              inventoryText
            );
          } else {
            var inventoryText =
              numberInStock == 1
                ? boostPFSConfig.label.in_stock_with_quantity_count.one
                : boostPFSConfig.label.in_stock_with_quantity_count.other;
            inventoryText = inventoryText.replace(/{{count}}/g, numberInStock);
            inventoryHtml = inventoryHtml.replace(
              /{{inventoryClass}}/g,
              " inventory--high"
            );
            inventoryHtml = inventoryHtml.replace(
              /{{inventoryText}}/g,
              inventoryText
            );
          }
        } else {
          if (
            data.variants[0].inventory_policy == "continue" &&
            data.variants[0].inventory_quantity <= 0
          ) {
            inventoryHtml = inventoryHtml.replace(
              /{{inventoryClass}}/g,
              " inventory--high"
            );
            inventoryHtml = inventoryHtml.replace(
              /{{inventoryText}}/g,
              boostPFSConfig.label.oversell_stock
            );
          } else {
            inventoryHtml = inventoryHtml.replace(
              /{{inventoryClass}}/g,
              " inventory--high"
            );
            inventoryHtml = inventoryHtml.replace(
              /{{inventoryText}}/g,
              boostPFSConfig.label.in_stock
            );
          }
        }
      } else {
        inventoryHtml = inventoryHtml.replace(/{{inventoryClass}}/g, "");
        inventoryHtml = inventoryHtml.replace(
          /{{inventoryText}}/g,
          boostPFSConfig.label.sold_out
        );
      }
    }
    return inventoryHtml;
  }

  // kopie van buildInventory met aanvullingen voor tonen van actuele voorraadstand
  function buildInventoryJAO(data) {
    var inventoryHtml = "";
    var incomingVariantsHtml = "";
    var incomingExplanationText;

    if (
      boostPFSConfig.custom.show_inventory_quantity &&
      data.template_suffix != "pre-order"
    ) {
      if (data.metafields.length > 1) {
        var incomingVariants = data.metafields.filter(function (metafield) {
          return metafield.key === "Incoming" && metafield.value === true;
        });
        if (incomingVariants.length > 0) {
          incomingVariantsHtml =
            '<div class="product-form__info-content incoming_date">' +
            `<span class="product-item__inventory inventory inventory--low">${ boostPFSConfig.label.sold_out_order_in_stock }</span>` +
            "</div>";
        }
      }

      inventoryHtml =
        '<span class="product-item__inventory inventory {{inventoryClass}} pfs-inventory">{{count}} {{inventoryText}} {{inventoryLowExplanation}}</span>';

      if (data.available) {
        var should_calculate_inventory = true;
        for (var i = 0; i < data.variants.length; i++) {
          var varianti = data.variants[i];
          if (
            varianti.inventory_policy == "continue" ||
            varianti.inventory_management == null
          ) {
            should_calculate_inventory = false;
            break;
          }
        }

        if (
          should_calculate_inventory &&
          boostPFSConfig.custom.low_inventory_threshold > 0
        ) {
          var numberInStock = 0;
          for (var j = 0; j < data.variants.length; j++) {
            var variantj = data.variants[j];
            if (variantj.inventory_management) {
              numberInStock += variantj.inventory_quantity;
            }
          }
          if (numberInStock <= boostPFSConfig.custom.low_inventory_threshold) {
            var inventoryText =
              numberInStock == 1
                ? boostPFSConfig.label.low_stock_with_quantity_count.one
                : boostPFSConfig.label.low_stock_with_quantity_count.other;
            inventoryText = inventoryText.replace(/{{count}}/g, numberInStock);
            inventoryHtml = inventoryHtml.replace(
              /{{inventoryClass}}/g,
              " inventory--low"
            );
            inventoryHtml = inventoryHtml.replace(
              /{{inventoryText}}/g,
              inventoryText
            );
          } else {
            var inventoryText =
              numberInStock == 1
                ? boostPFSConfig.label.in_stock_with_quantity_count.one
                : boostPFSConfig.label.in_stock_with_quantity_count.other;
            inventoryText = inventoryText.replace(/{{count}}/g, numberInStock);
            inventoryHtml = inventoryHtml.replace(
              /{{inventoryClass}}/g,
              " inventory--high"
            );
            inventoryHtml = inventoryHtml.replace(
              /{{inventoryText}}/g,
              inventoryText
            );
          }
        } else {
          // dit dus
          var numberInStock = 0;

          if (data.variant_id) {
            //console.log('is variant', data.variant_id);
            for (var i = 0; i < data.variants.length; i++) {
              if (data.variants[i].id == data.variant_id) {
                numberInStock = data.variants[i].inventory_quantity;
                break;
              }
            }
          } else {
            // product is geen variant, maar producten hebben standaard 1 variant
            for (var i = 0; i < data.variants.length; i++) {
              numberInStock += data.variants[i].inventory_quantity;
            }
          }

          // twee soorten voorraad: uitverkocht, of uitverkocht en bijbestelbaar ('continue selling when out of stock')
          // inventory_policy: "continue" of "deny"
          var delivery_time = data.metafields.filter(function (metafield) {
            return metafield.key === "levertijd" && metafield.value;
          });

          if (numberInStock <= 0) {
            // uitverkocht, maar nabestelling mogelijk
            inventoryHtml = inventoryHtml.replace(/{{count}}/g, "");
            inventoryHtml = inventoryHtml.replace(
              /{{inventoryClass}}/g,
              "inventory--high"
            );

            if (
              data.variants[0].inventory_policy == "continue" &&
              delivery_time != "" &&
              delivery_time.length > 0
            ) {
              inventoryHtml = inventoryHtml.replace(
                /{{inventoryText}}/g,
                //"Leverbaar in " + delivery_time[0].value + " werkdagen"
                boostPFSConfig.label.available_in_days
              );

              inventoryHtml = inventoryHtml.replace(/{{days}}/g, delivery_time[0].value)
            } else if (data.variants[0].inventory_policy == "continue") {
              inventoryHtml = inventoryHtml.replace(
                /{{inventoryText}}/g,
                boostPFSConfig.label.sold_out_order_in_stock
              );
            } else {
              inventoryHtml = inventoryHtml.replace(
                /{{inventoryText}}/g,
                boostPFSConfig.label.sold_out_order_in_stock // niet op voorraad
              );
            }
            inventoryHtml = inventoryHtml.replace(
              /{{inventoryLowExplanation}}/g,
              ''
              //'<span class="stock-help-container pointer"><img src="https://cdn.shopify.com/s/files/1/0275/8934/5359/files/a85652d129e05f2c819074406c1b1ca2_e3189bbc-4787-4a12-9510-1f9a319d630e.svg?7153" alt="Wat betekent dit?" class="stock-help-icon"></span>'
            );
          } else {
            // op voorraad
            inventoryHtml = inventoryHtml.replace(/{{count}}/g, numberInStock);
            inventoryHtml = inventoryHtml.replace(
              /{{inventoryClass}}/g,
              "inventory--high"
            );
            inventoryHtml = inventoryHtml.replace(
              /{{inventoryText}}/g,
              boostPFSConfig.label.in_stock
              //"op voorraad"
            );
            inventoryHtml = inventoryHtml.replace(
              /{{inventoryLowExplanation}}/g,
              ""
            );
          }
        }
      } else {
        // no data available
        inventoryHtml = inventoryHtml.replace(/{{count}}/g, "");
        inventoryHtml = inventoryHtml.replace(
          /{{inventoryLowExplanation}}/g,
          ""
        );
        inventoryHtml = inventoryHtml.replace(/{{inventoryClass}}/g, "");
        inventoryHtml = inventoryHtml.replace(
          /{{inventoryText}}/g,
          boostPFSConfig.label.sold_out
        );
      }
    }

    inventoryHtml += incomingVariantsHtml;
    return inventoryHtml;
  }

  function buildQuickView(data) {
    var quickViewHtml = "";
    var quickBuyHtml = "";
    if (
      boostPFSConfig.custom.show_quick_view == "list" ||
      boostPFSConfig.custom.show_quick_view == "list_grid" ||
      boostPFSConfig.custom.show_quick_buy == "list" ||
      boostPFSConfig.custom.show_quick_buy == "list_grid"
    ) {
      var quickViewClass =
        boostPFSConfig.custom.show_quick_buy == "list" &&
        boostPFSConfig.custom.show_quick_view == "list"
          ? "product-item__action-list--list-view-only"
          : "";
      var quickViewButtonClass =
        boostPFSConfig.custom.show_quick_view == "list"
          ? "product-item__action-button--list-view-only"
          : "";
      var quickBuyButtonClass =
        boostPFSConfig.custom.show_quick_buy == "list"
          ? "product-item__action-button--list-view-only"
          : "";
      var templateClass = boostPFSConfig.custom.template || "";

      //Quick buy button
      if (soldOut) {
        quickBuyHtml = boostPFSTemplate.quickBuySoldOutHtml;
      } else {
        if (data.variants && data.variants.length > 1) {
          quickBuyHtml = boostPFSTemplate.quickBuyChooseOptionsHtml;
        } else {
          quickBuyHtml = boostPFSTemplate.quickBuyHtml;
        }
      }
      quickBuyHtml = quickBuyHtml.replace(
        /{{quickBuyButtonClass}}/g,
        quickBuyButtonClass
      );

      //Quick view
      quickViewHtml = boostPFSTemplate.quickViewHtml;
      quickViewHtml = quickViewHtml.replace(/{{variantId}}/g, firstVariant.id);
      quickViewHtml = quickViewHtml.replace(/{{quickBuy}}/g, quickBuyHtml);
      quickViewHtml = quickViewHtml.replace(
        /{{quickViewClass}}/g,
        quickViewClass
      );
      quickViewHtml = quickViewHtml.replace(
        /{{templateClass}}/g,
        templateClass
      );
      quickViewHtml = quickViewHtml.replace(
        /{{quickViewButtonClass}}/g,
        quickViewButtonClass
      );
    }

    return quickViewHtml;
  }

  /***************************** BUILD TOOLBAR *******************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage > 1) {
      var paginationHtml = boostPFSTemplate.paginateHtml;
      // Build Previous
      var previousHtml =
        currentPage > 1 ? boostPFSTemplate.pageItemPreviousHtml : "";
      previousHtml = previousHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, currentPage - 1)
      );
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
      // Build Next
      var nextHtml =
        currentPage < totalPage ? boostPFSTemplate.pageItemNextHtml : "";
      nextHtml = nextHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, currentPage + 1)
      );
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
      // Create page items array
      var beforeCurrentPageArr = [];
      for (
        var iBefore = currentPage - 1;
        iBefore > currentPage - 3 && iBefore > 0;
        iBefore--
      ) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift("...");
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);
      var afterCurrentPageArr = [];
      for (
        var iAfter = currentPage + 1;
        iAfter < currentPage + 3 && iAfter <= totalPage;
        iAfter++
      ) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push("...");
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }
      // Build page items
      var pageItemsHtml = "";
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        var activeClass = "";
        var pageLink = "";
        if (pageArr[iPage] == currentPage) {
          activeClass = "is-active";
        } else if (pageArr[iPage] != "...") {
          activeClass = "link";
          pageLink = Utils.buildToolbarLink(
            "page",
            currentPage,
            pageArr[iPage]
          );
        }
        pageItemsHtml += boostPFSTemplate.pageItemHtml;
        pageItemsHtml = pageItemsHtml.replace(/{{activeClass}}/g, activeClass);
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, pageLink);
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

      return paginationHtml;
    }

    return "";
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    if (
      boostPFSConfig.custom.show_sorting &&
      boostPFSTemplate.hasOwnProperty("sortingHtml")
    ) {
      //jQ(Selector.topSorting).html('');
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        var paramSort = Globals.queryParams.sort || "";
        // Build content
        var sortingItemsHtml = "";
        this.activeName = "";
        for (var sortingValue in sortingArr) {
          var sortingItemHtml = boostPFSTemplate.sortingItemHtml;
          var activeClass = paramSort == sortingValue ? "is-selected" : "";
          var sortingName = sortingArr[sortingValue];
          if (paramSort == sortingValue) this.activeName = sortingName;
          sortingItemHtml = sortingItemHtml.replace(
            /{{sortingName}}/g,
            sortingName
          );
          sortingItemHtml = sortingItemHtml.replace(
            /{{sortingValue}}/g,
            sortingValue
          );
          sortingItemHtml = sortingItemHtml.replace(
            /{{sortingActiveClass}}/g,
            activeClass
          );
          sortingItemsHtml += sortingItemHtml;
        }
        var html = boostPFSTemplate.sortingHtml.replace(
          /{{sortingItems}}/g,
          sortingItemsHtml
        );
        return html;
      }
    }
  };

  // Sorting render
  ProductSorting.prototype.render = function () {
    var $selectInput = jQ(Selector.topSorting);
    var paramSort = Globals.queryParams.sort || "";
    $selectInput.html(this.compileTemplate());

    if ($selectInput.hasClass("boost-pfs-filter-sort-active")) {
      $selectInput.toggleClass("boost-pfs-filter-sort-active");
    }

    Labels.sorting = boostPFSConfig.label.sorting_title;

    var labelSort = "";
    var labelSortMobile = "";
    if (paramSort.length > 0 && this.activeName) {
      labelSort = Labels.sorting + ": " + this.activeName;
    } else {
      labelSort = Labels.sorting;
    }

    labelSortMobile = Labels.sorting;

    jQ(Selector.topSorting + " button span").text(labelSort);
    jQ(Selector.topSorting + " button span.hidden-tablet-and-up").text(
      labelSortMobile
    );
  };

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function () {
    var _this = this;
    jQ(Selector.topSorting + " button.value-picker__choice-item").click(
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        FilterApi.setParam("sort", jQ(this).data("sort"));
        FilterApi.setParam("page", 1);
        FilterApi.applyFilter("sort");
      }
    );
    jQ(Selector.topSorting + " button.value-picker-button").click(function (e) {
      var expandedValue =
        jQ(this).attr("aria-expanded") == "false" ? "true" : "false";
      var hiddenValue =
        jQ("#boost-sort-by-selector").attr("aria-hidden") == "false"
          ? "true"
          : "false";
      jQ(this).attr("aria-expanded", expandedValue);
      jQ("#boost-sort-by-selector").attr("aria-hidden", hiddenValue);
    });
    jQ(document).on("click", function (e) {
      var valueButton = Selector.topSorting + " .value-picker-button";
      if (
        jQ(e.target).closest(valueButton).length === 0 &&
        jQ(valueButton).eq(0).attr("aria-expanded") == "true"
      ) {
        jQ(valueButton).trigger("click");
      }
    });
  };

  // Build Show Limit
  ProductLimit.prototype.compileTemplate = function () {
    if (boostPFSTemplate.hasOwnProperty("showLimitHtml")) {
      var numberList = Settings.getSettingValue("general.showLimitList");
      var iconHtml =
        '<svg focusable="false" class="icon icon--check-2" viewBox="0 0 13 11" role="presentation"><path d="M1 4.166456L5.317719 9 12 1" stroke="currentColor" stroke-width="2" fill="none" fill-rule="evenodd"></path></svg>';
      if (numberList != "") {
        // Build content
        var showLimitItemsHtml = "";
        var arr = numberList.split(",");
        for (var k = 0; k < arr.length; k++) {
          if (arr[k] == Globals.queryParams.limit) {
            showLimitItemsHtml +=
              '<button class="value-picker__choice-item link is-selected" data-action="select-value" data-value="' +
              arr[k] +
              '">' +
              boostPFSConfig.label.page_size.replace(/{{page_size}}/g, arr[k]) +
              iconHtml +
              "</button>";
          } else {
            showLimitItemsHtml +=
              '<button class="value-picker__choice-item link" data-action="select-value" data-value="' +
              arr[k] +
              '">' +
              boostPFSConfig.label.page_size.replace(/{{page_size}}/g, arr[k]) +
              iconHtml +
              "</button>";
          }
        }
        var html = boostPFSTemplate.showLimitHtml.replace(
          /{{showLimitItems}}/g,
          showLimitItemsHtml
        );
        return html;
      }
    }
    return "";
  };

  // Build Limit render
  ProductLimit.prototype.render = function () {
    jQ(Selector.topShowLimit).html(this.compileTemplate());
    var $topLimitSelect = jQ(
      Selector.topShowLimit + " .value-picker-button .hidden-phone"
    );
    if ($topLimitSelect.length) {
      $topLimitSelect.html(
        boostPFSConfig.label.display +
          ": " +
          boostPFSConfig.label.page_size.replace(
            /{{page_size}}/g,
            Globals.queryParams.limit
          )
      );
    }
  };

  //Build Limit bindEvents
  ProductLimit.prototype.bindEvents = function () {
    jQ(Selector.topShowLimit + " .value-picker__choice-item").click(function (
      e
    ) {
      FilterApi.setParam("limit", jQ(this).data("value"));
      FilterApi.applyFilter();
    });
    jQ(Selector.topShowLimit + " button.value-picker-button").click(function (
      e
    ) {
      var expandedValue =
        jQ(this).attr("aria-expanded") == "false" ? "true" : "false";
      var hiddenValue =
        jQ("#boost-display-by-selector").attr("aria-hidden") == "false"
          ? "true"
          : "false";
      jQ(this).attr("aria-expanded", expandedValue);
      jQ("#boost-display-by-selector").attr("aria-hidden", hiddenValue);
    });
    jQ(document).on("click", function (e) {
      var valueButton = Selector.topShowLimit + " .value-picker-button";
      if (
        jQ(e.target).closest(valueButton).length === 0 &&
        jQ(valueButton).eq(0).attr("aria-expanded") == "true"
      ) {
        jQ(valueButton).trigger("click");
      }
    });
  };

  /************************ BUILD ADDITIONAL ELEMENTS *************************/
  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    if (window.SPR) {
      SPR.initDomEls();
      SPR.loadBadges();
    }

    if (boostPFSConfig.custom.currency_conversion_enabled) {
      convertAll();
    }

    document.querySelector("body").classList.add("boost-loaded");

    // update price for b2b (not in use)
    // runScript(true);

    // tooltips for out of stock products
    setTimeout(setTooltip, 800);

    // event handlers for convert.com
    setTimeout(bindConvertBtns, 650);

    bindPopupHandler();
  };

  // Build additional elements
  Filter.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;

    buildProductCount(data);
    buildSearchBreadcrumbs(data);
    buildDisplayType();
    styleFilterIcon(data);

    jQ("body").find(".boost-pfs-filter-skeleton-button").remove();
    jQ('a.boost-pfs-filter-scroll-to-top[target="_blank"]').removeAttr(
      "target"
    );
  };

  function convertAll(selector) {
    var _this = this;

    var moneyFormats = {
      USD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} USD",
      },
      EUR: {
        money_format: "&euro;{{amount}}",
        money_with_currency_format: "&euro;{{amount}} EUR",
      },
      GBP: {
        money_format: "&pound;{{amount}}",
        money_with_currency_format: "&pound;{{amount}} GBP",
      },
      CAD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} CAD",
      },
      ALL: {
        money_format: "Lek {{amount}}",
        money_with_currency_format: "Lek {{amount}} ALL",
      },
      DZD: {
        money_format: "DA {{amount}}",
        money_with_currency_format: "DA {{amount}} DZD",
      },
      AOA: {
        money_format: "Kz{{amount}}",
        money_with_currency_format: "Kz{{amount}} AOA",
      },
      ARS: {
        money_format: "${{amount_with_comma_separator}}",
        money_with_currency_format: "${{amount_with_comma_separator}} ARS",
      },
      AMD: {
        money_format: "{{amount}} AMD",
        money_with_currency_format: "{{amount}} AMD",
      },
      AWG: {
        money_format: "Afl{{amount}}",
        money_with_currency_format: "Afl{{amount}} AWG",
      },
      AUD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} AUD",
      },
      BBD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} Bds",
      },
      AZN: {
        money_format: "m.{{amount}}",
        money_with_currency_format: "m.{{amount}} AZN",
      },
      BDT: {
        money_format: "Tk {{amount}}",
        money_with_currency_format: "Tk {{amount}} BDT",
      },
      BSD: {
        money_format: "BS${{amount}}",
        money_with_currency_format: "BS${{amount}} BSD",
      },
      BHD: {
        money_format: "{{amount}} BD",
        money_with_currency_format: "{{amount}} BHD",
      },
      BYR: {
        money_format: "Br {{amount}}",
        money_with_currency_format: "Br {{amount}} BYR",
      },
      BZD: {
        money_format: "BZ${{amount}}",
        money_with_currency_format: "BZ${{amount}} BZD",
      },
      BTN: {
        money_format: "Nu {{amount}}",
        money_with_currency_format: "Nu {{amount}} BTN",
      },
      BAM: {
        money_format: "KM {{amount_with_comma_separator}}",
        money_with_currency_format: "KM {{amount_with_comma_separator}} BAM",
      },
      BRL: {
        money_format: "R$ {{amount_with_comma_separator}}",
        money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL",
      },
      BOB: {
        money_format: "Bs{{amount_with_comma_separator}}",
        money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB",
      },
      BWP: {
        money_format: "P{{amount}}",
        money_with_currency_format: "P{{amount}} BWP",
      },
      BND: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} BND",
      },
      BGN: {
        money_format: "{{amount}} Ð»Ð²",
        money_with_currency_format: "{{amount}} Ð»Ð² BGN",
      },
      MMK: {
        money_format: "K{{amount}}",
        money_with_currency_format: "K{{amount}} MMK",
      },
      KHR: {
        money_format: "KHR{{amount}}",
        money_with_currency_format: "KHR{{amount}}",
      },
      KYD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} KYD",
      },
      XAF: {
        money_format: "FCFA{{amount}}",
        money_with_currency_format: "FCFA{{amount}} XAF",
      },
      CLP: {
        money_format: "${{amount_no_decimals}}",
        money_with_currency_format: "${{amount_no_decimals}} CLP",
      },
      CNY: {
        money_format: "&#165;{{amount}}",
        money_with_currency_format: "&#165;{{amount}} CNY",
      },
      COP: {
        money_format: "${{amount_with_comma_separator}}",
        money_with_currency_format: "${{amount_with_comma_separator}} COP",
      },
      CRC: {
        money_format: "&#8353; {{amount_with_comma_separator}}",
        money_with_currency_format:
          "&#8353; {{amount_with_comma_separator}} CRC",
      },
      HRK: {
        money_format: "{{amount_with_comma_separator}} kn",
        money_with_currency_format: "{{amount_with_comma_separator}} kn HRK",
      },
      CZK: {
        money_format: "{{amount_with_comma_separator}} K&#269;",
        money_with_currency_format: "{{amount_with_comma_separator}} K&#269;",
      },
      DKK: {
        money_format: "{{amount_with_comma_separator}}",
        money_with_currency_format: "kr.{{amount_with_comma_separator}}",
      },
      DOP: {
        money_format: "RD$ {{amount}}",
        money_with_currency_format: "RD$ {{amount}}",
      },
      XCD: {
        money_format: "${{amount}}",
        money_with_currency_format: "EC${{amount}}",
      },
      EGP: {
        money_format: "LE {{amount}}",
        money_with_currency_format: "LE {{amount}} EGP",
      },
      ETB: {
        money_format: "Br{{amount}}",
        money_with_currency_format: "Br{{amount}} ETB",
      },
      XPF: {
        money_format: "{{amount_no_decimals_with_comma_separator}} XPF",
        money_with_currency_format:
          "{{amount_no_decimals_with_comma_separator}} XPF",
      },
      FJD: {
        money_format: "${{amount}}",
        money_with_currency_format: "FJ${{amount}}",
      },
      GMD: {
        money_format: "D {{amount}}",
        money_with_currency_format: "D {{amount}} GMD",
      },
      GHS: {
        money_format: "GH&#8373;{{amount}}",
        money_with_currency_format: "GH&#8373;{{amount}}",
      },
      GTQ: {
        money_format: "Q{{amount}}",
        money_with_currency_format: "{{amount}} GTQ",
      },
      GYD: {
        money_format: "G${{amount}}",
        money_with_currency_format: "${{amount}} GYD",
      },
      GEL: {
        money_format: "{{amount}} GEL",
        money_with_currency_format: "{{amount}} GEL",
      },
      HNL: {
        money_format: "L {{amount}}",
        money_with_currency_format: "L {{amount}} HNL",
      },
      HKD: {
        money_format: "${{amount}}",
        money_with_currency_format: "HK${{amount}}",
      },
      HUF: {
        money_format: "{{amount_no_decimals_with_comma_separator}}",
        money_with_currency_format:
          "{{amount_no_decimals_with_comma_separator}} Ft",
      },
      ISK: {
        money_format: "{{amount_no_decimals}} kr",
        money_with_currency_format: "{{amount_no_decimals}} kr ISK",
      },
      INR: {
        money_format: "Rs. {{amount}}",
        money_with_currency_format: "Rs. {{amount}}",
      },
      IDR: {
        money_format: "{{amount_with_comma_separator}}",
        money_with_currency_format: "Rp {{amount_with_comma_separator}}",
      },
      ILS: {
        money_format: "{{amount}} NIS",
        money_with_currency_format: "{{amount}} NIS",
      },
      JMD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} JMD",
      },
      JPY: {
        money_format: "&#165;{{amount_no_decimals}}",
        money_with_currency_format: "&#165;{{amount_no_decimals}} JPY",
      },
      JEP: {
        money_format: "&pound;{{amount}}",
        money_with_currency_format: "&pound;{{amount}} JEP",
      },
      JOD: {
        money_format: "{{amount}} JD",
        money_with_currency_format: "{{amount}} JOD",
      },
      KZT: {
        money_format: "{{amount}} KZT",
        money_with_currency_format: "{{amount}} KZT",
      },
      KES: {
        money_format: "KSh{{amount}}",
        money_with_currency_format: "KSh{{amount}}",
      },
      KWD: {
        money_format: "{{amount}} KD",
        money_with_currency_format: "{{amount}} KWD",
      },
      KGS: {
        money_format: "Ð»Ð²{{amount}}",
        money_with_currency_format: "Ð»Ð²{{amount}}",
      },
      LVL: {
        money_format: "Ls {{amount}}",
        money_with_currency_format: "Ls {{amount}} LVL",
      },
      LBP: {
        money_format: "L&pound;{{amount}}",
        money_with_currency_format: "L&pound;{{amount}} LBP",
      },
      LTL: {
        money_format: "{{amount}} Lt",
        money_with_currency_format: "{{amount}} Lt",
      },
      MGA: {
        money_format: "Ar {{amount}}",
        money_with_currency_format: "Ar {{amount}} MGA",
      },
      MKD: {
        money_format: "Ð´ÐµÐ½ {{amount}}",
        money_with_currency_format: "Ð´ÐµÐ½ {{amount}} MKD",
      },
      MOP: {
        money_format: "MOP${{amount}}",
        money_with_currency_format: "MOP${{amount}}",
      },
      MVR: {
        money_format: "Rf{{amount}}",
        money_with_currency_format: "Rf{{amount}} MRf",
      },
      MXN: {
        money_format: "$ {{amount}}",
        money_with_currency_format: "$ {{amount}} MXN",
      },
      MYR: {
        money_format: "RM{{amount}} MYR",
        money_with_currency_format: "RM{{amount}} MYR",
      },
      MUR: {
        money_format: "Rs {{amount}}",
        money_with_currency_format: "Rs {{amount}} MUR",
      },
      MDL: {
        money_format: "{{amount}} MDL",
        money_with_currency_format: "{{amount}} MDL",
      },
      MAD: {
        money_format: "{{amount}} dh",
        money_with_currency_format: "Dh {{amount}} MAD",
      },
      MNT: {
        money_format: "{{amount_no_decimals}} &#8366",
        money_with_currency_format: "{{amount_no_decimals}} MNT",
      },
      MZN: {
        money_format: "{{amount}} Mt",
        money_with_currency_format: "Mt {{amount}} MZN",
      },
      NAD: {
        money_format: "N${{amount}}",
        money_with_currency_format: "N${{amount}} NAD",
      },
      NPR: {
        money_format: "Rs{{amount}}",
        money_with_currency_format: "Rs{{amount}} NPR",
      },
      ANG: {
        money_format: "&fnof;{{amount}}",
        money_with_currency_format: "{{amount}} NA&fnof;",
      },
      NZD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} NZD",
      },
      NIO: {
        money_format: "C${{amount}}",
        money_with_currency_format: "C${{amount}} NIO",
      },
      NGN: {
        money_format: "&#8358;{{amount}}",
        money_with_currency_format: "&#8358;{{amount}} NGN",
      },
      NOK: {
        money_format: "kr {{amount_with_comma_separator}}",
        money_with_currency_format: "kr {{amount_with_comma_separator}} NOK",
      },
      OMR: {
        money_format: "{{amount_with_comma_separator}} OMR",
        money_with_currency_format: "{{amount_with_comma_separator}} OMR",
      },
      PKR: {
        money_format: "Rs.{{amount}}",
        money_with_currency_format: "Rs.{{amount}} PKR",
      },
      PGK: {
        money_format: "K {{amount}}",
        money_with_currency_format: "K {{amount}} PGK",
      },
      PYG: {
        money_format: "Gs. {{amount_no_decimals_with_comma_separator}}",
        money_with_currency_format:
          "Gs. {{amount_no_decimals_with_comma_separator}} PYG",
      },
      PEN: {
        money_format: "S/. {{amount}}",
        money_with_currency_format: "S/. {{amount}} PEN",
      },
      PHP: {
        money_format: "&#8369;{{amount}}",
        money_with_currency_format: "&#8369;{{amount}} PHP",
      },
      PLN: {
        money_format: "{{amount_with_comma_separator}} zl",
        money_with_currency_format: "{{amount_with_comma_separator}} zl PLN",
      },
      QAR: {
        money_format: "QAR {{amount_with_comma_separator}}",
        money_with_currency_format: "QAR {{amount_with_comma_separator}}",
      },
      RON: {
        money_format: "{{amount_with_comma_separator}} lei",
        money_with_currency_format: "{{amount_with_comma_separator}} lei RON",
      },
      RUB: {
        money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
        money_with_currency_format:
          "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB",
      },
      RWF: {
        money_format: "{{amount_no_decimals}} RF",
        money_with_currency_format: "{{amount_no_decimals}} RWF",
      },
      WST: {
        money_format: "WS$ {{amount}}",
        money_with_currency_format: "WS$ {{amount}} WST",
      },
      SAR: {
        money_format: "{{amount}} SR",
        money_with_currency_format: "{{amount}} SAR",
      },
      STD: {
        money_format: "Db {{amount}}",
        money_with_currency_format: "Db {{amount}} STD",
      },
      RSD: {
        money_format: "{{amount}} RSD",
        money_with_currency_format: "{{amount}} RSD",
      },
      SCR: {
        money_format: "Rs {{amount}}",
        money_with_currency_format: "Rs {{amount}} SCR",
      },
      SGD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} SGD",
      },
      SYP: {
        money_format: "S&pound;{{amount}}",
        money_with_currency_format: "S&pound;{{amount}} SYP",
      },
      ZAR: {
        money_format: "R {{amount}}",
        money_with_currency_format: "R {{amount}} ZAR",
      },
      KRW: {
        money_format: "&#8361;{{amount_no_decimals}}",
        money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW",
      },
      LKR: {
        money_format: "Rs {{amount}}",
        money_with_currency_format: "Rs {{amount}} LKR",
      },
      SEK: {
        money_format: "{{amount_no_decimals}} kr",
        money_with_currency_format: "{{amount_no_decimals}} kr SEK",
      },
      CHF: {
        money_format: "{{amount}} CHF",
        money_with_currency_format: "{{amount}} CHF",
      },
      TWD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} TWD",
      },
      THB: {
        money_format: "{{amount}} &#xe3f;",
        money_with_currency_format: "{{amount}} &#xe3f; THB",
      },
      TZS: {
        money_format: "{{amount}} TZS",
        money_with_currency_format: "{{amount}} TZS",
      },
      TTD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} TTD",
      },
      TND: {
        money_format: "{{amount}}",
        money_with_currency_format: "{{amount}} DT",
      },
      TRY: {
        money_format: "{{amount}}TL",
        money_with_currency_format: "{{amount}}TL",
      },
      UGX: {
        money_format: "Ush {{amount_no_decimals}}",
        money_with_currency_format: "Ush {{amount_no_decimals}} UGX",
      },
      UAH: {
        money_format: "₴{{amount}}",
        money_with_currency_format: "{{amount}} UAH",
      },
      AED: {
        money_format: "Dhs. {{amount}}",
        money_with_currency_format: "Dhs. {{amount}} AED",
      },
      UYU: {
        money_format: "${{amount_with_comma_separator}}",
        money_with_currency_format: "${{amount_with_comma_separator}} UYU",
      },
      VUV: {
        money_format: "{{amount}} VT",
        money_with_currency_format: "{{amount}} VT",
      },
      VEF: {
        money_format: "Bs. {{amount_with_comma_separator}}",
        money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF",
      },
      VND: {
        money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;",
        money_with_currency_format:
          "{{amount_no_decimals_with_comma_separator}} VND",
      },
      XBT: {
        money_format: "{{amount_no_decimals}} BTC",
        money_with_currency_format: "{{amount_no_decimals}} BTC",
      },
      XOF: {
        money_format: "CFA{{amount}}",
        money_with_currency_format: "CFA{{amount}} XOF",
      },
      ZMW: {
        money_format: "K{{amount_no_decimals_with_comma_separator}}",
        money_with_currency_format:
          "ZMW{{amount_no_decimals_with_comma_separator}}",
      },
    };

    var baseCurrency = window.theme.shopCurrency,
      newCurrency = document.querySelector(".currency-selector").value;

    (selector || document)
      .querySelectorAll("[data-money-convertible]")
      .forEach(function (item) {
        if (!item.hasAttribute("data-currency-" + baseCurrency)) {
          item.setAttribute("data-currency-" + baseCurrency, item.innerHTML);
        }

        // If the amount has already been converted, we leave it alone.
        if (item.getAttribute("data-currency") === newCurrency) {
          return;
        }

        var baseAmount = item.getAttribute("data-currency-" + baseCurrency);

        // If we are converting to a currency that we have saved, we will use the saved amount.
        if (item.hasAttribute("data-currency-" + newCurrency)) {
          item.innerHTML = item.getAttribute("data-currency-" + newCurrency);
        } else {
          var newFormat =
            moneyFormats[newCurrency][
              window.theme.currencyConversionMoneyFormat
            ] || "{{amount}}";

          // We have to normalize by replacing dot by comma and comma by dot
          if (window.theme.moneyFormat.indexOf("with_comma_separator") !== -1) {
            baseAmount = baseAmount.replace(/[,.]/g, function (match) {
              // If `,` is matched return `.`, if `.` matched return `,`
              return match === "," ? "." : ",";
            });
          }

          // Converting to Y for the first time? Let's get to it!
          var cents = window.Currency.convert(
            parseFloat(baseAmount.replace(/^[^0-9]+|[^0-9.]/g, "", ""), 10) *
              100,
            baseCurrency,
            newCurrency
          );

          if (window.theme.currencyConversionRoundAmounts) {
            cents = Math.round(cents / 100) * 100;
          }
          var newFormattedAmount = Utils.formatMoney(cents, newFormat);

          item.innerHTML = newFormattedAmount;
          item.setAttribute("data-currency-" + newCurrency, newFormattedAmount);
        }

        // We record the new currency locally.
        item.setAttribute("data-currency", newCurrency);
      });

    localStorage.setItem("currency", newCurrency);
  }

  function buildProductCount(data) {
    var fromProduct =
      (Globals.queryParams.page - 1) * Globals.queryParams.limit + 1;
    var toProduct = Math.min(
      fromProduct + (Globals.queryParams.limit - 1),
      data.total_product
    );
    var totalProduct = boostPFSConfig.label.showing_count.other;
    if (data.total_product == 1) {
      totalProduct = boostPFSConfig.label.showing_count.one;
    } else if (data.total_product == 0) {
      totalProduct = boostPFSConfig.label.showing_count.zero;
    }
    totalProduct = totalProduct.replace(/{{offset}}/g, fromProduct);
    totalProduct = totalProduct.replace(/{{page_size}}/g, toProduct);
    totalProduct = totalProduct.replace(/{{count}}/g, data.total_product);
    jQ(".boost-pfs-filter-total-product").each(function () {
      jQ(this).html(totalProduct);
    });
  }

  function buildSearchBreadcrumbs(data) {
    if (Globals.currentTerm) {
      var terms = Utils.escape(Globals.currentTerm.trim());
      var breadcrumbsText =
        boostPFSConfig.label.search_title_with_terms.replace(
          /{{terms}}/g,
          terms
        );
      jQ(".boost-pfs-breadcrumbs").each(function () {
        jQ(this).html(breadcrumbsText);
      });
    }
  }

  function buildDisplayType() {
    if (!Utils.isMobile()) {
      var selectedLayout = jQ('.is-selected[data-action="change-layout"]');
      if (selectedLayout.length > 0) {
        selectedLayout.removeClass("is-selected");
        selectedLayout.click();
      } else {
        jQ('[data-action="change-layout"]:first').click();
      }
    }
  }

  function styleFilterIcon(data) {
    var queryParams = Object.keys(Globals.queryParams);
    var prefix = Globals.queryParams["_"];
    var isFiltered = false;
    for (var i = 0; i < queryParams.length; i++) {
      var queryParam = queryParams[i];
      if (queryParam.startsWith(prefix)) {
        isFiltered = true;
        break;
      }
    }
    if (isFiltered) {
      jQ(".collection__filter-icon").addClass(
        "collection__filter-icon--active"
      );
    } else {
      jQ(".collection__filter-icon").removeClass(
        "collection__filter-icon--active"
      );
    }
  }
})(); // Add this at the end

// tooltip voor uitverkochte producten (beetje delay om filter te laten laden)
// wordt (ook) aangeroepen vanuit pagination functie
function setTooltip() {
  if (document.querySelectorAll(".stock-help-container").length > 0) {
    //console.log('setTooltip');
    tippy(".stock-help-container", {
      content: boostPFSConfig.label.restock_tooltip
    });
  } else {
    setTimeout(setTooltip, 1500);
  }
}

window._conv_q = window._conv_q || [];
function bindConvertBtns() {
  document
    .querySelectorAll("button[data-action=add-to-cart]")
    .forEach((btn) => {
      btn.addEventListener("click", (evt) => {
        _conv_q.push(["triggerConversion", "100414255"]);
      });
    });
}

function bindPopupHandler() {
  document
    .querySelectorAll("button.product-item__action-button--list-view-only")
    .forEach((btn) => {
      btn.addEventListener("click", (event) => {
        setTimeout(function () {
          gimPoll(
            function () {
              return BSS_B2B.cpRuleChoice;
            },
            3000,
            150
          )
            .then(function () {
              let productId = event.srcElement.dataset.productId;
              BSS_B2B.cpRuleChoice.forEach((discountRule) => {
                if (discountRule.id == productId) {
                  let discountPerc = 100 / parseFloat(discountRule.value);
                  let m2 = document.querySelector(
                    ".price-list .part-price[data-value]"
                  );
                  if (m2) {
                    let perM2 = m2.dataset.value;
                    let newPerM2 = perM2 / discountPerc / 100;
                    m2.firstChild.textContent = BSS_B2B.formatMoney(
                      newPerM2.toFixed(2).toString()
                    );
                    m2.style.display = "unset";
                    m2.setAttribute("bss-custom-price-active", "true");
                  } // if m2
                  let vats = document.querySelectorAll(
                    ".unit-price-exvat, .part-price-exvat"
                  );
                  vats.forEach((v) => {
                    if (v.dataset.value) {
                      var exVat = v.dataset.value / discountPerc / 100;
                      v.querySelector("span").textContent = BSS_B2B.formatMoney(
                        exVat.toFixed(2).toString()
                      );
                    }
                  }); // foreach vat
                } // discountRule applies
              });
            })
            .catch(function () {});
        }, 500);

        runScript(true);
      }); // event listener
    }); // foreach
}
